(function () {
  var GIFT_RULES = {
    '004154': ['004731', '003866'],
    '005448': ['003867', '004153'],
    '003449': ['004153', '004734'],
    '004150': ['004729', '003867'],
    '004155': ['003867', '004734'],
    '004152': ['003867', '004734'],
    '004145': ['004738', '003867'],
    '005446': ['005447'],
  };

  var GIFT_SKUS = ['003867', '004153', '004734', '004729', '004738', '005447', '004731', '003866'];
  var MINIMUM_SUBTOTAL = 8900; // R$89,00 em centavos

  var CHECKOUT_SELECTORS = '[data-action="open-checkout"], button[name="checkout"], a[href$="/checkout"]';

  var _timer = null;
  var DEBOUNCE_DELAY = 400;

  function normalizeSku(sku) {
    return (sku || '').replace(/^'/, '').trim();
  }

  function removeItem(id) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ id: id, quantity: 0 }),
    });
  }

  // Retorna subtotal pago em centavos (exclui itens com price = 0, ou seja, brindes)
  function getPaidSubtotal(items) {
    return items.reduce(function (sum, item) {
      return item.price > 0 ? sum + item.final_line_price : sum;
    }, 0);
  }

  // Retorna true se o carrinho não está vazio e NENHUM item tem preço base pago
  // (ou seja, é só brinde/grátis) — independente de o SKU estar mapeado ou não.
  function isEntirelyFree(items) {
    return items.length > 0 && items.every(function (item) { return item.price === 0; });
  }

  // Retorna Promise<string[]> com os SKUs removidos ([] se nenhum).
  // Dispara cart:refresh quando remove ao menos um item.
  function checkAndRemoveOrphanGifts() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cart.items || [];

        if (items.length === 0) return [];

        // Trava geral: carrinho com subtotal pago R$0 — zera tudo, mesmo que o
        // SKU não esteja em GIFT_RULES/GIFT_SKUS (protege contra brinde novo
        // que a gente ainda não mapeou).
        if (isEntirelyFree(items)) {
          var allSkus = items.map(function (item) { return normalizeSku(item.sku); });
          var wipeRemovals = items.map(function (item) { return removeItem(item.id); });
          console.log('[KF Gift Remover] Carrinho 100% grátis (nenhum produto pago) — removendo todos os itens:', allSkus);
          return Promise.all(wipeRemovals).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return allSkus;
          });
        }

        var triggers = items.filter(function (item) {
          return GIFT_RULES[normalizeSku(item.sku)];
        });

        var gifts = items.filter(function (item) {
          return GIFT_SKUS.indexOf(normalizeSku(item.sku)) !== -1;
        });

        if (gifts.length === 0) return [];

        var paidSubtotal = getPaidSubtotal(items);
        var belowMinimum = paidSubtotal < MINIMUM_SUBTOTAL;

        // Monta set de SKUs de brindes permitidos pelos triggers presentes
        var allowed = {};
        triggers.forEach(function (item) {
          var permitted = GIFT_RULES[normalizeSku(item.sku)] || [];
          permitted.forEach(function (sku) { allowed[sku] = true; });
        });

        var removals = [];
        var removedOrphan = [];
        var removedMinimum = [];

        gifts.forEach(function (item) {
          var sku = normalizeSku(item.sku);
          if (!allowed[sku]) {
            // Brinde órfão: trigger ausente
            removals.push(removeItem(item.id));
            removedOrphan.push(sku);
          } else if (belowMinimum) {
            // Brinde permitido por trigger, mas subtotal pago abaixo do mínimo
            removals.push(removeItem(item.id));
            removedMinimum.push(sku);
          }
        });

        if (removedOrphan.length > 0) {
          console.log('[KF Gift Remover] brindes removidos:', removedOrphan);
        }
        if (removedMinimum.length > 0) {
          console.log('[KF Gift Remover] Subtotal abaixo de R$89 — removendo brinde(s) órfão(s):', removedMinimum);
        }

        var removed = removedOrphan.concat(removedMinimum);

        if (removals.length > 0) {
          return Promise.all(removals).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return removed;
          });
        }

        return removed;
      })
      .catch(function (err) {
        console.warn('[KF Gift Remover] Erro ao verificar carrinho:', err);
        return [];
      });
  }

  function debounce() {
    clearTimeout(_timer);
    _timer = setTimeout(checkAndRemoveOrphanGifts, DEBOUNCE_DELAY);
  }

  // Bloqueio no checkout em capture phase — dispara antes do redirect do tema.
  // Reutiliza checkAndRemoveOrphanGifts: barra órfãos E belowMinimum antes de prosseguir.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_SELECTORS);
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    checkAndRemoveOrphanGifts()
      .then(function (removed) {
        if (removed.length > 0) {
          // Brindes inválidos removidos — exibe carrinho atualizado ao cliente
          return;
        }
        window.location.href = '/cart?view=fast';
      })
      .catch(function (err) {
        console.warn('[KF Gift Remover] Erro no bloqueio de checkout:', err);
        window.location.href = '/cart?view=fast';
      });
  }, true); // capture phase

  // Verificação inicial: aguarda Dr. Free Gift inicializar (500ms); 2000ms como fallback.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(checkAndRemoveOrphanGifts, 500);
    setTimeout(checkAndRemoveOrphanGifts, 2000);
  });

  // cart:change é o evento real disparado pelo tema (Impact) em add/remove/troca de quantidade.
  // cart:updated é mantido por segurança, caso algum app dispare esse nome especificamente.
  document.addEventListener('cart:change', debounce);
  document.addEventListener('cart:updated', debounce);
  document.addEventListener('cart:refresh', debounce);
  document.addEventListener('cart:drawer:open', debounce);
})();
